<script setup>
  import { ref, onMounted, onUnmounted, watch, nextTick } from "vue";
  import { useRoute } from "vue-router";
  import { throttle } from "lodash-es";

  const showButton = ref(false);
  const route = useRoute();

  const handleScroll = throttle(() => {
    const scrollTop = window.scrollY;
    const windowHeight = window.innerHeight;
    const docHeight = document.documentElement.scrollHeight;
    const threshold = 30;
    showButton.value =
      scrollTop + windowHeight >= docHeight - threshold ||
      docHeight <= windowHeight;
  }, 200);

  const moveScrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  onMounted(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });
  });

  onUnmounted(() => {
    window.removeEventListener("scroll", handleScroll);
  });

  watch(
    () => route.fullPath,
    async () => {
      await nextTick(); // 렌더링 끝날 때까지 기다림
      handleScroll();
    },
  );
</script>

<template>
  <button
    :style="
      showButton
        ? 'opacity: 1; visibility: visible;'
        : 'opacity: 0; visibility: hidden;'
    "
    @click="moveScrollTop"
  >
    <img src="@/assets/images/ic_arrow_top.png" alt="scroll top" />
  </button>
</template>

<style lang="scss" scoped>
  button {
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--smoe-white);
    border-radius: 100%;
    bottom: 2.5rem;
    box-shadow: 0 4px 15px 0 rgba(0, 0, 0, 0.15);
    height: 60px;
    position: fixed;
    right: max(1rem, calc((100% - 1400px) / 2));
    width: 60px;
    transition: 0.2s ease-in-out;
    z-index: 10;
    img {
      width: 20px;
    }
  }
</style>
